// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2JT7n","bigColWidth":"Table_bigColWidth__2Kadh","biggerColWidth":"Table_biggerColWidth__16TLp","row":"Table_row__2FLc_","col":"Table_col__15nPW"};